// src/pages/StudentDashboard.jsx
//
// PLAN S11a: the shell only. Verified students land here instead of the
// generic Dashboard (src/components/Dashboard.jsx decides which one to
// render — see that file's isVerifiedStudent check, which reads
// GET /free-tier/status). Filled in by later sub-steps:
//   S11b — a nav / quick-links strip for the four tools
//   S11c — the progress widget (days left, sessions used/3, projects x/8)
//   S11e — a link to the Community page
//   S11d — the feedback card (also fulfills the master plan's S12)
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, ArrowRight } from 'lucide-react';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import StudentFeedbackCard from '../components/StudentFeedbackCard';
import StudentPlanWidget from '../components/StudentPlanWidget';
import StudentToolLinks from '../components/StudentToolLinks';

const StudentDashboard = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Student Dashboard"
        description="Your ProducerBuddy student plan: track your free tier, projects, and tools."
        url="https://producerbuddy.pilomation.com/student-dashboard"
        robots="noindex, nofollow"
      />
      <SubNav />
      <div className="min-h-screen bg-gray-50 px-6 py-8">
        <h1 className="text-2xl font-bold text-slate-800 mb-6">Your Student Dashboard</h1>
        <StudentFeedbackCard />
        <StudentPlanWidget />
        <StudentToolLinks />

        {/* PLAN S11e: link to the real Community page (route path keeps its
            existing typo, /Comunity - matching Routing.js, not fixed here). */}
        <button
          onClick={() => navigate('/Comunity')}
          className="w-full flex items-center justify-between gap-3 rounded-2xl border border-gray-200 bg-white hover:border-teal-400 hover:bg-teal-50 p-5 mb-6 transition-colors text-left"
        >
          <span className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-full flex items-center justify-center bg-teal-600/10 text-teal-600">
              <MessageCircle size={18} />
            </span>
            <span>
              <span className="block font-semibold text-slate-800">Community</span>
              <span className="block text-sm text-slate-500">Connect with other filmmakers and alumni</span>
            </span>
          </span>
          <ArrowRight size={18} className="text-teal-600 flex-shrink-0" />
        </button>
      </div>
    </>
  );
};

export default StudentDashboard;
